import Container from 'components/Container'
import { FC } from 'react'
import { ComponentWithClassName } from 'types/custom'
import { Spin } from 'antd'

const Loader: FC<ComponentWithClassName> = ({ className }) => (
	<Container
		display="flex"
		alignItems="center"
		justifyContent="center"
		min={{ width: '100%', height: '100%' }}
		className={className}
	>
		<Spin size="large" />
	</Container>
)

export default Loader
